import styled from 'styled-components';

export const AdvertiserLogoStyle = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-start;
  .advertiserLogo {
    &__container {
      margin: var(--spacing-10) 0 0 0;
      display: flex;
      flex-direction: column;
    }

    &__buttonWrapper {
      align-items: center;
      display: flex;
    }

    &__preview {
      background: ${props => props.theme.uiColors.selectorBgDisabled};
      display: flex;
      height: 100px;
      justify-content: center;
      margin-right: 16px;
      width: 194px;
    }

    &__image {
      max-height: 100%;
      max-width: 100%;
    }

    &__span {
      color: ${props => props.theme.grayLight};
      font-family: ${props => props.theme.fontRegular}, serif;
      font-size: ${props => props.theme.fontSizeXS};
      margin-left: 8px;
    }
    &__deleteButton {
      padding: 12px 16px;
    }

    &__label {
      color: var(--color-taptap-primary-darkblue);
      font: var(--font-info-600-bold);
      margin-bottom: 8px;

      &--disabled {
        color: var(--color-status-disabled-500);
      }
    }

    &__button {
      color: ${props => props.theme.uiColors.advertiserLogoMainColor};
      font-family: ${props => props.theme.fontSemiBold}, serif;
      font-size: ${props => props.theme.fontSizeXS};
      background-color: ${props => props.theme.uiColors.advertiserLogoBackgroundColor};
      border: 1px solid ${props => props.theme.uiColors.advertiserLogoBorderColor};
      height: 38px;
      padding: 0 8px;
      width: 187px;

      &--uploaded {
        color: ${props => props.theme.uiColors.interactionDefault};
        border: 1px solid ${props => props.theme.uiColors.advertiserLogoBorderColor};
        font-family: ${props => props.theme.fontSemiBold}, serif;
        font-size: ${props => props.theme.fontSizeXS};
        padding: 8px;
      }
    }
  }
`;
